import { useQuery } from "@apollo/client/react";
import { OrganizationalRecordAccessDocument, type AccessScopeKind } from "@/graphql/generated/operations";

export type OrganizationalRecordAccess = { canRead: boolean; canWrite: boolean; canAnalyzePowers?: boolean; readScope: AccessScopeKind | null };

/** `skip`: a page with no subject to keep a file about (the company page on /c/new) asks nothing and reads as denied. */
export function useOrganizationalRecordAccess({ skip = false }: { skip?: boolean } = {}): OrganizationalRecordAccess {
  // The profile entry point and panel share this fresh check, including after role revocation.
  const { data, error } = useQuery(OrganizationalRecordAccessDocument, {
    fetchPolicy: "no-cache",
    pollInterval: 60_000,
    notifyOnNetworkStatusChange: false,
    skip,
  });
  const canRead = !skip && !error && data?.organizationalRecordAccess.canRead === true;
  return { canRead, canWrite: canRead && data?.organizationalRecordAccess.canWrite === true,
    readScope: canRead ? data?.organizationalRecordAccess.readScope?.kind ?? null : null,
    canAnalyzePowers: canRead && data?.organizationalRecordAccess.canAnalyzePowers === true };
}
